<app-content-header [contentHeader]="contentHeader"></app-content-header>

<div class="card">
    <form [formGroup]="deliveryForm">
        <div class="row col-12">
            <div class="form-group col-xl-3 col-md-6 col-sm-12">
                <label for="company">Firma</label>
                <div class="form-group">
                    <ng-select [items]="companies" bindLabel="companyName" bindValue="id" formControlName="companyId"
                        (change)="onCompanySelect($event)" (search)="searchCompany($event)"></ng-select>
                    <div *ngIf="deliveryForm.get('companyId').hasError('required') && deliveryForm.get('companyId').touched"
                        class="text-danger">
                        Firma seçimi zorunludur.
                    </div>
                </div>
            </div>

            <div class="form-group col-xl-3 col-md-6 col-sm-12">
                <label for="company">İlgili Kişi</label>
                <div class="form-group">
                    <ng-select formControlName="companyPersonId">
                        <ng-option *ngFor="let user of companyPersons" [value]="user.id">{{user.name + ' '
                            + user.lastName}}</ng-option>
                    </ng-select>
                </div>
            </div>

            <div class="form-group col-xl-3 col-md-6 col-sm-12">
                <label for="company">Teklif</label>
                <div class="form-group">
                    <ng-select formControlName="transactionManagementId">
                        <ng-option *ngFor="let transaction of transactionManagements"
                            [value]="transaction.id">{{transaction.createdAt |
                            date:'dd.MM.yyyy'}}-{{transaction.no}}-{{getStatusText(transaction.status)}}
                        </ng-option>
                    </ng-select>
                </div>
            </div>

            <div class="form-group col-xl-3 col-md-6 col-sm-12">
                <div class="form-group">
                    <label>Teslim Alma Tarihi</label>
                    <div class="form-group">
                        <ng2-flatpickr [config]="dateTimeStartOptions" [setDate]="date" name="dateTime"
                            formControlName="deliveryDate"></ng2-flatpickr>
                    </div>
                </div>
            </div>

            <div class="form-group col-xl-3 col-md-6 col-sm-12">
                <label for="company">Teslim Alan Personel</label>
                <div class="form-group">
                    <ng-select formControlName="personId">
                        <ng-option *ngFor="let user of persons" [value]="user.id">{{user.name + ' '
                            + user.lastName}}
                        </ng-option>
                    </ng-select>
                </div>
            </div>

            <div class="form-group col-xl-3 col-md-6 col-sm-12">
                <label for="company">Teslim Şekli</label>
                <div class="form-group">
                    <ng-select [items]="deliveryMethods" bindLabel="deliveryMethodName" bindValue="id"
                        formControlName="deliveryMethodId"></ng-select>
                    <div *ngIf="deliveryForm.get('deliveryMethodId').hasError('required') && deliveryForm.get('deliveryMethodId').touched"
                        class="text-danger">
                        Teslim şekli zorunludur.
                    </div>
                </div>
            </div>

            <div class="form-group col-xl-3 col-md-6 col-sm-12">
                <label for="company">Getiren Kişi</label>
                <div class="form-group">
                    <input type="text" id="deliveryPerson" class="form-control" placeholder="Getiren Kişi"
                        maxlength="50" formControlName="deliveryPerson" />
                </div>
            </div>

            <div class="form-group col-xl-3 col-md-6 col-sm-12">
                <div class="form-group">
                    <label>Açıklama</label>
                    <div class="form-group">
                        <textarea class="form-control" id="basicTextarea" rows="1" placeholder="Açıklama."
                            formControlName="description"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="card">
    <div class="row col-12">
        <div class="col-xl-6 col-md-6 col-sm-12"
            [ngClass]="{ 'ng-select-disabled': !selectedCompanyId || !deliveryForm.get('deliveryMethodId').value }">
            <label>Cihaz Seç</label>
            <div class="form-group">
                <ng-select [items]="devices" bindLabel="brandName" bindValue="id" [searchFn]="searchDevice"
                    (change)="onDeviceSelect($event)" [clearable]="true" [formControl]="deviceControl">
                    <ng-template ng-header-tmp>
                        <button
                            class="add-new-customer btn btn-flat-success cursor-pointer rounded-0 text-left p-50 w-100"
                            (click)="showCreateDeviceDialog(); select.blur(); select.close()">
                            <i data-feather="plus"></i>
                            <span class="align-middle ml-25">Yeni Cihaz Ekle</span>
                        </button>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <h6 class="mb-1">{{item.deviceName}}</h6>
                        <p class="card-subtitle mb-2 text-muted">
                            {{ item.brandName }} / {{item.modelName}} - {{item.seriNo}} - {{item.typeName}}
                        </p>
                    </ng-template>
                </ng-select>
            </div>
        </div>
    </div>
    <div class="table-responsive" *ngIf="deviceList.length > 0">
        <table class="table">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Seri No</th>
                    <th>Marka Model</th>
                    <th>Tür</th>
                    <th>Sertfika Basılcak Firma</th>
                    <th>#</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of deviceList; let i = index;">
                    <td>{{i+1}}</td>
                    <td>
                        {{item.seriNo}}
                    </td>
                    <td>
                        {{item.brandName}} - {{item.modelName}}
                    </td>
                    <td>
                        {{item.typeName}}
                    </td>
                    <td>
                        {{item.company.companyName}}
                    </td>
                    <td>
                        <button type="button" class="btn btn-icon btn-flat-danger"
                            (click)="removeDeliveryDevice(item.id)" rippleEffect>
                            <span [data-feather]="'trash'"></span></button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<div class="d-flex justify-content-end">
    <button type="button" class="btn btn-success" rippleEffect (click)="onSumbit()"
        [disabled]="!deliveryForm.valid || deviceList.length < 1">Kaydet</button>
</div>